/**
 * @deprecated Replaced with UserRole from package/auth
 */
export enum ApiUserRole {
  Manager = 'manager',
  Viewer = 'viewer',
}

export interface IApiUser {
  userId: string;
  username: string;
  roles: ApiUserRole[];
  email: string;
  firstName: string;
  lastName: string;
}

export interface IApiNewUser {
  email: string;
  username: string;
  password: string;
  roles: ApiUserRole[];
  firstName: string;
  lastName: string;
}
